import { Box, HStack, Image, Text, Button, Flex } from "@chakra-ui/react";
export function ProjectCard({data}){
    return (
        <>
         <div id="projects" style={{width:"70%", margin:"auto"}} >
        <Box style={{
        padding:"10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        width:"100%",
         borderRadius:"10px",
          textAlign:"center" }} >
          <img
          style={{display:"block", margin:"auto", marginBottom:"30px", width:"100%", borderRadius:"20px", boxShadow:"rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset"}}
            src={require(`../files/${data.img}`)}
            // borderRadius={"20px"}
            // boxShadow= ""
            // mb={"30px"}
          />
        <Box className="singleText project-card" style={{padding:"10px", textAlign:"center"}}>
          <Text className="project-title"  textAlign={"left"} mb="10px" fontSize={"xl"}> <b>Title : </b>{data.title} </Text>
          <Text className="project-description" textAlign={"left"} mb="10px"> <b>Description : </b>{data.desc} </Text>
          <Text className="project-tech-stack" textAlign={"left"} mb="10px"><b>Tech stack : </b>{data.techStack} </Text>
          <Text textAlign={"left"} mb="30px"><b>Feature : </b>{data.feature} </Text>
          <HStack gap={"30px"} >
          <Button className="project-github-link" onClick={()=>window.open(data.clone,"_blank")}>Github</Button>
          <Button  className="project-deployed-link" onClick={()=>window.open(data.deploy,"_blank")}>Visit Site</Button>

          </HStack>
        </Box>
        </Box>
         </div>
        </>
    )
}